import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../reducers";
import {useTranslation, withTranslation} from "react-i18next";
import Money from "../Common/Money";
import {getCart} from "../../services/Cart/reducer";

interface OwnProps {
    goToCart: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartButtonComponent = (props: Props) => {
    const cart = props.cart;
    const {t} = useTranslation();
    const disabled = cart.pending || cart.id == undefined || cart.items.length === 0;
    const loading = cart.pending;

    const getTitle = () => {
        let title = t("modules.cart.action.go_to_order.title");

        if(cart.total > 0) {
            title += " • ";
        }

        return title;
    }

    return (
        <button onClick={props.goToCart}
                className={"btn-spinner btn btn-primary btn-submit" + (loading ? ' loading' : '')} disabled={disabled}>
            <span className="left spinner-border spinner-border-sm"/>
            {getTitle()}
            {cart.total > 0 &&  <Money value={cart.total}/>}
        </button>
    )
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartButtonComponent));